let THREE = require("three"); // To silence the warning

// IMPORTS:
const config = require(/*! ../config.js */"../config.js");
const GEOS = require(/*! ../libs/geos.js */"../libs/geos.js");
const UTILS = require(/*! ../libs/utils.js */"../libs/utils.js");
const WEAPONS = require(/*! ../data/weapons.js */"./weapons.js");

// LOAD OBJ:
let textureLoader = new THREE.TextureLoader();
let loadManager = new THREE.LoadingManager();
let objLoader = new THREE.OBJLoader(loadManager);
function loadObj(parent, src, textureSrc, scale, colr, yOffset = 0, xR = 0, yR = 0, foo = null) {
  return new Promise(resolve => {
    objLoader.load(UTILS.versionifyUrl(src), model => {
      let texture;
      if (textureSrc) {
        texture = textureLoader.load(UTILS.versionifyUrl(textureSrc), texture => {
          texture.wrapS = THREE.RepeatWrapping;
          texture.wrapT = THREE.RepeatWrapping;
          texture.repeat.set(1, 1);
          texture.minFilter = THREE.NearestFilter;
          texture.magFilter = THREE.NearestFilter;
          texture.needsUpdate = true;
        });
      }
      let material = new THREE.StrippedLambertMaterial({
        map: texture
      });
      let tmpGeometry = new THREE.Geometry();
      model.traverse(child => {
        if (child instanceof THREE.Mesh) {
          if (child.geometry.isBufferGeometry) {
            tmpGeometry.fromBufferGeometry(child.geometry);
            tmpGeometry.computeFlatVertexNormals();
            child.geometry.fromGeometry(tmpGeometry);
          } else {
            child.geometry.computeFlatVertexNormals();
          }
          child.material = material;
        }
      });
      material.vertexColors = THREE.VertexColors;
      material.color.set(colr || 0xffffff);
      model.scale.setScalar(scale || 1);
      model.position.y = model.position.y + yOffset;
      model.rotateX(xR || 0);
      model.rotateY(yR || 0);
      if (foo) {
        if (parent[foo]) {
          parent.remove(parent[foo]);
          parent[foo] = null;
        }
        parent[foo] = model;
        parent.add(parent[foo]);
      } else {
        parent.add(model);
      }
      resolve(model);
    });
  });
}

// GENERATE MESH:
const cubeGeometry = new THREE.BoxBufferGeometry(1, 1, 1);
const planeGeometry = new THREE.PlaneBufferGeometry(1, 1);
planeGeometry.rotateX(-Math.PI / 2);
const ladderMaterial = new THREE.StrippedLambertMaterial({
  color: 0x00ff00
});
const cubeMaterial = new THREE.StrippedLambertMaterial({
  color: 0x555555
});

// GENERATE SPRITE:
function generateSprite(parent, src, scale) {
  let spriteMap = new THREE.TextureLoader().load(UTILS.versionifyUrl(src));
  spriteMap.magFilter = THREE.NearestFilter;
  let spriteMaterial = new THREE.SpriteMaterial({
    map: spriteMap,
    color: 0xffffff
  });
  let sprite = new THREE.Sprite(spriteMaterial);
  if (scale) {
    sprite.scale.set(scale, scale, 1);
  }
  parent.add(sprite);
}

// GENERATE PLANE:
function generatePlane(w, l) {
  let geo = new THREE.PlaneGeometry(w, l);
  geo.rotateX(-Math.PI / 2);
  return geo;
}

// GENERATE CUBE:
function generateCube(x, y, z, amb) {
  var tmpGeo = GEOS.generateCube([1, 1, 1, 1, 1, 1], x, y, z, {
    scale: 1,
    amb: amb,
    useScale: true
  });
  tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
  return tmpGeo;
}

// GENERATE RAMP:
function generateRamp(x, y, z, w, h, l, dir) {
  var geo = new THREE.Geometry();
  dir = dir * Math.PI / 2;
  y = 0 - h / 2;
  var rot = dir != 0 && dir != Math.PI;
  let addRamp = (x, y, z, w, h, l, dir, data, zD) => {
    data = data || {};
    var mesh = new THREE.Mesh(GEOS.generatePlane(l * 2, w, data));
    mesh.position.set(x, y + h / 2, z);
    l *= 2;
    var rl = Math.sqrt(h * h + l * l);
    mesh.scale.set(w, rl, 2);
    mesh.rotateY(-(Math.PI / 2) - dir);
    mesh.rotateX(Math.asin(h / rl) - Math.PI / 2);
    mesh.rotateZ(zD || 0);
    mesh.updateMatrix();
    geo.merge(mesh.geometry, mesh.matrix);
  };
  addRamp(x, y, z, rot ? w : l, h, (rot ? l : w) / 2, dir, {
    scale: 1
  });
  return geo;
}
let addPlane = (geo, x, y, z, w, l, data, xR, yR, zR) => {
  data = data || {};
  data.premultipliedAlpha = true;
  var mesh = new THREE.Mesh(GEOS.generatePlane(l, w, data, x, y, z));
  mesh.position.set(x, y, z);
  mesh.rotateY(xR || 0);
  mesh.rotateX((yR || 0) - Math.PI / 2);
  mesh.rotateZ(zR || 0);
  mesh.scale.set(w * 2, l * 2, 1);
  mesh.updateMatrix();
  geo.merge(mesh.geometry, mesh.matrix);
};
let addCube = (parent, x, y, z, w, h, l, sides, data) => {
  data = data || {};
  var mesh = new THREE.Mesh(GEOS.generateCube(sides, w, h, l, data));
  mesh.position.set(x, y, z);
  mesh.rotation.set(data.yR || 0, data.xR || 0, data.zR || 0);
  mesh.scale.set(w, h, l);
  //if (data.src && !data.noGroup) this.meshGroup(mesh, data);
  if (parent instanceof THREE.Geometry) {
    mesh.updateMatrix();
    parent.merge(mesh.geometry, mesh.matrix);
  } else {
    parent.add(mesh);
  }
  return mesh;
};

// GENERATE LADDER:
function generateLadder(w, h, l, d) {
  var geo = new THREE.Geometry();
  d = d * Math.PI / 2;
  let tmpObj = {
    x: 0 + config.ladderScale * Math.cos(d),
    z: 0 + config.ladderScale * Math.sin(d),
    y: 0 - h / 2
  };
  addCube(geo, tmpObj.x + config.ladderWidth * Math.sin(d), tmpObj.y, tmpObj.z + config.ladderWidth * Math.cos(d), config.ladderScale * 2, h + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], {
    scale: 0.02
  });
  addCube(geo, tmpObj.x - config.ladderWidth * Math.sin(d), tmpObj.y, tmpObj.z - config.ladderWidth * Math.cos(d), config.ladderScale * 2, h + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], {
    scale: 0.02
  });
  var stepH = 6;
  var max = Math.floor(h / stepH);
  for (var i = 0; i < max; ++i) {
    addPlane(geo, tmpObj.x, tmpObj.y + stepH * (i + 1) + UTILS.randFloat(-1, 1), tmpObj.z, config.ladderWidth, config.ladderScale, {
      scale: 0.02
    }, -d + Math.PI / 2, Math.PI / 2, UTILS.randFloat(-0.1, 0.1));
  }
  return geo;
}

// GENERATE BILLBOARD:
function generateBillboard(x, y, z, w, h, l) {
  var geo = new THREE.Geometry();
  addPlane(geo, x, y, z, w / 2, l / 2);
  return geo;
}
function generateFlag(parent, amb) {
  let crystal = loadObj(parent, "models/crystal_0.obj", "textures/crystal_0.png", config.flagScale, 0xffffff, config.flagOff / 2);
  var tmpGeo = GEOS.generateCube([1, 1, 0, 0, 1, 1], ...parent.size, {
    scale: 1,
    amb: amb,
    useScale: true,
    transparent: true,
    depthWrite: false,
    side: 2
  });
  tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
  return tmpGeo;
}
function generateWeapon(parent, amb) {
  let tmpGeo = GEOS.generateCube([1, 1, 1, 1, 1, 1], ...parent.size, {
    scale: 1,
    amb: amb,
    useScale: true
  });
  tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
  let weapon = loadObj(parent, "models/weapons/" + WEAPONS[parent.weaponId].src + ".obj", "textures/weapons/" + WEAPONS[parent.weaponId].src + ".png", WEAPONS[parent.weaponId].scale, 0xffffff, -0.5, -1.6, 0, 'wepMesh');
  return tmpGeo;
}
function generateSpawn(parent, amb) {
  let spawn = loadObj(parent, "models/spawn_0.obj", "textures/spawn_0.png", 1, 0xffffff, -5.5, 0, -((parent.direction || 0) + 1) * Math.PI / 2, 'spwnMesh');
  let tmpGeo = GEOS.generateCube([1, 1, 1, 1, 1, 1], 7, 11, 7, {
    scale: 1,
    amb: amb,
    transparent: true,
    useScale: true,
    depthWrite: false,
    side: 2
  });
  tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
  return tmpGeo;
}
function generateBorder(x, y, z, amb) {
  var geo = new THREE.Geometry();
  var tmpGeo = new THREE.SphereGeometry(.5, 32, 32);
  var mesh = new THREE.Mesh(tmpGeo);
  mesh.scale.set(x, y, z);
  mesh.updateMatrix();
  geo.merge(mesh.geometry, mesh.matrix);
  geo = new THREE.BufferGeometry().fromGeometry(geo);
  return geo;
}
function generateGrass(w, h, l, amb) {
  let tmpGeo = new THREE.Geometry();
  let angle = Math.PI * 2 * Math.random();
  let tmpMesh = new THREE.Mesh(GEOS.generatePlane(w, h, {}));
  tmpMesh.scale.set(w, h, l);
  tmpMesh.rotateY(angle * (Math.PI / 2));
  tmpMesh.updateMatrix();
  tmpGeo.merge(tmpMesh.geometry, tmpMesh.matrix);
  let tmpMesh2 = new THREE.Mesh(GEOS.generatePlane(w, h, {}));
  tmpMesh2.scale.set(w, h, l);
  tmpMesh2.rotateY((angle + 1) * (Math.PI / 2));
  tmpMesh2.updateMatrix();
  tmpGeo.merge(tmpMesh2.geometry, tmpMesh2.matrix);
  tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
  return tmpGeo;
}

// PREFABS:
module.exports.prefabs = {
  CRATE: {
    editColor: true,
    dontRound: true,
    gen: parent => loadObj(parent, "models/crate_0.obj", "textures/crate_0.png", config.crateScale, parent.color),
    dummy: false,
    castShadow: true,
    receiveShadow: true
  },
  STACK: {
    editColor: true,
    dontRound: true,
    gen: parent => loadObj(parent, "models/stack_0.obj", "textures/stack_0.png", config.crateScale, parent.color),
    dummy: false,
    castShadow: true,
    receiveShadow: true
  },
  BARREL: {
    editColor: true,
    dontRound: true,
    gen: parent => loadObj(parent, "models/barrel_0.obj", "textures/barrel_0.png", config.barrelScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  ACIDBARREL: {
    editColor: true,
    dontRound: true,
    emiss: true,
    gen: parent => loadObj(parent, "models/acidbarrel_0.obj", "textures/acidbarrel_0.png", config.acidbarrelScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  TREE: {
    editColor: true,
    dontRound: true,
    complex: true,
    gen: parent => loadObj(parent, "models/tree_0.obj", "textures/tree_0.png", config.treeScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  CONE: {
    editColor: true,
    dontRound: true,
    complex: true,
    gen: parent => loadObj(parent, "models/cone_0.obj", "textures/cone_0.png", config.coneScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  CONTAINER: {
    editColor: true,
    dontRound: true,
    gen: parent => loadObj(parent, "models/container_0.obj", "textures/container_0.png", config.containerScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  CONTAINERR: {
    editColor: true,
    dontRound: true,
    gen: parent => loadObj(parent, "models/containerr_0.obj", "textures/containerr_0.png", config.containerScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  DOOR: {
    editColor: true,
    dontRound: true,
    gen: parent => loadObj(parent, "models/door_0.obj", "textures/door_0.png", config.doorScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  WINDOW: {
    editColor: true,
    dontRound: true,
    gen: parent => loadObj(parent, "models/window_0.obj", "textures/window_0.png", config.windowScale, parent.color),
    castShadow: true,
    transparent: true,
    receiveShadow: true
  },
  GRASS: {
    editColor: true,
    complex: true,
    doubleSide: true,
    transparent: true,
    gen: parent => loadObj(parent, "models/grass_0.obj", "textures/grass_0.png", config.grassScale, parent.color),
    receiveShadow: true
  },
  WEAPON_PICKUP: {
    defaultSize: [config.pickupZoneX, config.pickupZoneH, config.pickupZoneZ],
    scalable: false,
    tool: true,
    scaleWithSize: false,
    lineCol: 0x36DBFF,
    noTexture: true,
    texturable: false,
    opacity: 0.1,
    genGeo: async (instance, amb) => generateWeapon(instance, amb),
    stepSrc: "a"
  },
  /*GRASS: {
      noCollision: true,
      defaultSize: [12, 6, 12],
      scalable: true,
      editAmb: true,
      scaleWithSize: false,
      editColor: true,
      editEmissive: true,
      hideBoundingBox: false,
      genGeo: async (instance, amb) => generateGrass(...instance.size, amb),
      stepSrc: "a",
      dummy: false,
      castShadow: true,
      receiveShadow: true,
      alphaTest: 0.2,
      transparent: true,
      receiveShadow: true,
      doubleSide: true
  },*/
  VEHICLE: {
    editColor: true,
    dontRound: true,
    complex: true,
    emiss: true,
    gen: parent => loadObj(parent, "models/vehicle_0.obj", "textures/vehicle_0.png", config.vehicleScale, parent.color),
    castShadow: true,
    receiveShadow: true
  },
  LADDER: {
    defaultSize: [2, 10, 4],
    scalable: true,
    scaleWithSize: false,
    editColor: true,
    hideBoundingBox: false,
    texturable: true,
    genGeo: async instance => generateLadder(...instance.size, instance.direction),
    customDirection: true,
    stepSrc: "a",
    dummy: false,
    castShadow: true,
    receiveShadow: true
  },
  CUBE: {
    canTrigger: true,
    movingTexture: true,
    defaultSize: [10, 10, 10],
    hasHealth: true,
    scalable: true,
    editAmb: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    editPen: true,
    texturable: true,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a",
    dummy: false,
    castShadow: true,
    receiveShadow: true,
    hasBorder: true
  },
  RAMP: {
    defaultSize: [10, 5, 10],
    movingTexture: true,
    scalable: true,
    scaleWithSize: false,
    hideBoundingBox: false,
    boostable: true,
    editColor: true,
    texturable: true,
    genGeo: async instance => generateRamp(0, 0, 0, ...instance.size, instance.direction),
    shootable: true,
    customDirection: true,
    stepSrc: "a",
    dummy: false,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true
  },
  PLANE: {
    defaultSize: [4, 0.01, 4],
    movingTexture: true,
    dontRound: true,
    scalable: true,
    canTerrain: true,
    edgeNoise: true,
    scaleWithSize: true,
    editColor: true,
    editPen: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    texturable: true,
    genGeo: async instance => generatePlane(instance.size[0], instance.size[2]),
    stepSrc: "a",
    dummy: false,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true
  },
  OBJECTIVE: {
    defaultSize: [50, 50, 50],
    scalable: true,
    noTexture: true,
    opacity: 0.2,
    lineCol: 0xC800FF,
    tool: true,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a"
  },
  PARTICLES: {
    defaultSize: [20, 20, 20],
    hasParticles: true,
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 0x2EFFFF,
    tool: true,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a"
  },
  BILLBOARD: {
    defaultSize: [40, 0.01, 10],
    lineCol: 0xffff00,
    dontRound: true,
    scalable: true,
    canTerrain: true,
    scaleWithSize: true,
    hideBoundingBox: false,
    genGeo: async instance => generateBillboard(0, 0, 0, ...instance.size),
    stepSrc: "a",
    dummy: false,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true
  },
  SCORE_ZONE: {
    customScore: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 0xffff00,
    tool: true,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a"
  },
  DEATH_ZONE: {
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 0xff0000,
    tool: true,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a"
  },
  SPAWN_POINT: {
    scalable: false,
    alwaysSee: true,
    tool: true,
    scaleWithSize: false,
    teamable: true,
    noTexture: true,
    opacity: 0.00001,
    stepSrc: "a",
    customDirection: true,
    dontRound: true,
    genGeo: async (instance, amb) => generateSpawn(instance, amb),
    dummy: false,
    castShadow: false,
    receiveShadow: false
  },
  CHECK_POINT: {
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 0x03dac5,
    tool: true,
    customDirection: true,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a"
  },
  TELEPORTER: {
    hasSignals: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 0xb1fff0,
    tool: true,
    //customDirection: true,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a"
  },
  CAMERA_POSITION: {
    defaultSize: [2, 2, 2],
    scalable: false,
    alwaysSee: true,
    tool: true,
    scaleWithSize: false,
    hideBoundingBox: true,
    editorGen: parent => generateSprite(parent, "img/crosshair.png", 5),
    stepSrc: "a",
    dummy: false,
    castShadow: false,
    receiveShadow: false
  },
  FLAG: {
    defaultSize: [config.flagZoneS, config.flagZoneH, config.flagZoneS],
    scalable: false,
    tool: true,
    scaleWithSize: false,
    lineCol: 0xC800FF,
    teamable: true,
    noDefault: true,
    genGeo: async (instance, amb) => generateFlag(instance, amb),
    stepSrc: "a",
    dummy: false,
    castShadow: false,
    receiveShadow: false
  },
  WATER: {
    noExport: true,
    movingTexture: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    forceCollision: true,
    editAmb: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a",
    dummy: false,
    castShadow: true,
    receiveShadow: true
  },
  PLACEHOLDER: {
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    noExport: true,
    tool: true,
    opacity: 0.1,
    lineCol: 0x000000,
    genGeo: async (instance, amb) => generateCube(...instance.size, amb),
    stepSrc: "a"
  }
};

// TEXTURE PREFABS:
module.exports.texturePrefabs = {
  WALL: {
    src: "wall_0",
    filter: THREE.NearestFilter
  },
  DIRT: {
    src: "dirt_0",
    filter: THREE.NearestFilter
  },
  FLOOR: {
    src: "floor_0",
    filter: THREE.NearestFilter
  },
  GRID: {
    src: "grid_0",
    filter: THREE.NearestFilter
  },
  GREY: {
    src: "grey_0",
    filter: THREE.NearestFilter
  },
  DEFAULT: {
    src: "default",
    filter: THREE.NearestFilter
  },
  ROOF: {
    src: "roof_0",
    filter: THREE.NearestFilter
  },
  FLAG: {
    src: "flag_0",
    filter: THREE.NearestFilter
  },
  CHECK: {
    src: "check_0",
    filter: THREE.NearestFilter
  },
  GRASS: {
    src: "grass_1",
    filter: THREE.NearestFilter
  },
  LINES: {
    src: "lines_0",
    filter: THREE.NearestFilter
  },
  BRICK: {
    src: "brick_0",
    filter: THREE.NearestFilter
  },
  LINK: {
    src: "link_0",
    trans: true,
    filter: THREE.NearestFilter
  }
};
let getTexture = src => {
  return {
    src: src,
    filter: THREE.NearestFilter
  };
};
// LOAD TEXTURE:
module.exports.loadTexturePrefab = function (id, instance = null) {
  let prefab = instance.objType != "BILLBOARD" ? module.exports.texturePrefabs[id] : getTexture("pubs/b_" + (instance.poster || UTILS.randInt(1, config.billboardCnt)));
  prefab = instance.objType != "FLAG" ? prefab : getTexture("zone_r");
  //prefab = instance.objType != "GRASS" ? prefab : getTexture("grass_0");

  if (prefab.src == "default") {
    return;
  }
  return textureLoader.load(UTILS.versionifyUrl("/textures/" + prefab.src + ".png"), texture => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.minFilter = prefab.filter;
    texture.magFilter = prefab.filter;
    texture.needsUpdate = true;
  });
};